/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesFleetDtosCreateVehicleCheckRequest,
  FacilityFlowCoreModulesFleetDtosCreateVehicleRequest,
  FacilityFlowCoreModulesFleetDtosUpdateVehicleRequest,
  FacilityFlowCoreModulesFleetDtosVehicleCheckDto,
  FacilityFlowCoreModulesFleetDtosVehicleDto,
  GetApiV1VehiclesParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getVehicles = () => {
/**
 * @summary List vehicles with their current odometer reading and open trip (FAFD-26);
activeOnly hides deactivated ones.
 */
const getApiV1Vehicles = (
    params?: GetApiV1VehiclesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosVehicleDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosVehicleDto[]>(
      {url: `/api/v1/vehicles`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Register a vehicle, optionally with its initial odometer reading.
 */
const postApiV1Vehicles = (
    facilityFlowCoreModulesFleetDtosCreateVehicleRequest: FacilityFlowCoreModulesFleetDtosCreateVehicleRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosVehicleDto>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosVehicleDto>(
      {url: `/api/v1/vehicles`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesFleetDtosCreateVehicleRequest
    },
      options);
    }
  /**
 * @summary Change description or active state of a vehicle; the license plate is fixed. A new
odometer value is recorded as a correction in the logbook.
 */
const putApiV1VehiclesId = (
    id: string,
    facilityFlowCoreModulesFleetDtosUpdateVehicleRequest: FacilityFlowCoreModulesFleetDtosUpdateVehicleRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosVehicleDto>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosVehicleDto>(
      {url: `/api/v1/vehicles/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesFleetDtosUpdateVehicleRequest
    },
      options);
    }
  /**
 * @summary All first aid kit, inspection and vignette checks of a vehicle, newest first (FAFD-69).
 */
const getApiV1VehiclesIdChecks = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosVehicleCheckDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosVehicleCheckDto[]>(
      {url: `/api/v1/vehicles/${id}/checks`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Record until when a vehicle's first aid kit, inspection („Pickerl“) or vignette is valid
(FAFD-69). Earlier checks are kept as history.
 */
const postApiV1VehiclesIdChecks = (
    id: string,
    facilityFlowCoreModulesFleetDtosCreateVehicleCheckRequest: FacilityFlowCoreModulesFleetDtosCreateVehicleCheckRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosVehicleCheckDto>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosVehicleCheckDto>(
      {url: `/api/v1/vehicles/${id}/checks`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesFleetDtosCreateVehicleCheckRequest
    },
      options);
    }
  return {getApiV1Vehicles,postApiV1Vehicles,putApiV1VehiclesId,getApiV1VehiclesIdChecks,postApiV1VehiclesIdChecks}};
export type GetApiV1VehiclesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getVehicles>['getApiV1Vehicles']>>>
export type PostApiV1VehiclesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getVehicles>['postApiV1Vehicles']>>>
export type PutApiV1VehiclesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getVehicles>['putApiV1VehiclesId']>>>
export type GetApiV1VehiclesIdChecksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getVehicles>['getApiV1VehiclesIdChecks']>>>
export type PostApiV1VehiclesIdChecksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getVehicles>['postApiV1VehiclesIdChecks']>>>
